import { render, staticRenderFns } from "./PackImport.vue?vue&type=template&id=2b880be4&scoped=true&"
import script from "./PackImport.vue?vue&type=script&lang=js&"
export * from "./PackImport.vue?vue&type=script&lang=js&"
import style0 from "./PackImport.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PackImport.vue?vue&type=style&index=1&id=2b880be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b880be4",
  null
  
)

export default component.exports